// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__34Wb2","requiredAsterisk":"Info_requiredAsterisk__1KlpO"};